import { render, staticRenderFns } from "./NeoparentDownload.vue?vue&type=template&id=649fe837&scoped=true"
import script from "./NeoparentDownload.vue?vue&type=script&lang=js"
export * from "./NeoparentDownload.vue?vue&type=script&lang=js"
import style0 from "./NeoparentDownload.vue?vue&type=style&index=0&id=649fe837&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649fe837",
  null
  
)

export default component.exports